<template>
  <div class="modal fade" id="shipping-info-modal" role="dialog" @click="$emit('close')">
    <div class="modal-dialog modal-lg" @click.stop>
      <div class="modal-content additonal-modal-content bd-rds-16">
        <div class="pd-t-20 pd-b-20 pd-l-20 pd-r-20">
          <p class="text-size-20 font-bold">出荷情報</p>
          <dl>
            <dt>配送業者</dt>
            <dd :class="[{'no-data' : !selectShipping.resultTransporterName}]">{{ selectShipping.resultTransporterName || '（商品の出荷後に表示）' }}</dd>
            <dt>お問い合わせ番号</dt>
            <dd :class="[{'no-data' : !selectShipping.trackingCodes.length}]" class="flexbox mr-b-30">
              <span v-if="!selectShipping.trackingCodes.length">（商品の出荷後に表示）</span>
              <div v-else class="flex-container flex-direction-column">
                <div class="box" v-for="(trackingCode, key) in selectShipping.trackingCodes" :key="key">
                  <span>{{ trackingCode }}</span>
                  <button v-if="trackingCode" type="button" @click="handleClickCoppy(trackingCode)" class="product-bubble-wrapper">
                    <i class="fa fa-clipboard" aria-hidden="true" data-toggle="tooltip"></i>
                    <div v-show="selectedTrackingCode === trackingCode" class="product-bubble bubble">
                      コピーしました
                    </div>
                  </button>
                </div>
              </div>
            </dd>
            <dt>お届け先名</dt>
            <dd :class="[{'no-data' : !selectShipping.toName}]">{{ selectShipping.toName || '（確定後に表示）' }}</dd>
            <dt>郵便番号</dt>
            <dd :class="[{'no-data' : !selectShipping.toPostalCode}]">{{ selectShipping.toPostalCode || '（確定後に表示）' }}</dd>
            <dt>住所</dt>
            <dd :class="[{'no-data' : !selectShipping.toAddress}]">{{ selectShipping.toAddress || '（確定後に表示）' }}</dd>
            <dt>電話番号</dt>
            <dd :class="[{'no-data' : !selectShipping.toPhoneNo}]">{{ selectShipping.toPhoneNo || '（確定後に表示）' }}</dd>
          </dl>
          <div class="text-center">
            <button type="button" @click="$emit('close')" class="btn text-size-14">閉じる</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    selectShipping: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      loader: null,
      selectedTrackingCode: null
    }
  },
  methods: {
    handleClickCoppy (trackingCode) {
      if (!trackingCode) {
        return false
      }
      this.selectedTrackingCode = trackingCode
      navigator.clipboard.writeText(trackingCode)
      setTimeout(() => {
        this.selectedTrackingCode = null
      }, 1000)
    }
  },
  mounted () {
    $('#shipping-info-modal').modal('show')
  },
  beforeDestroy () {
    this.$emit('close')
    $('.modal-backdrop').remove()
  }
}
</script>

<style scoped>
.flex-container {
  display: flex;
  align-items: stretch;
}
.box {
  flex: 1;
  min-width: max-content;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 5px;
  padding: 5px;
}
#shipping-info-modal .modal-lg {
  width: 500px;
}
#shipping-info-modal dt {
  margin-left: 30px;
}
#shipping-info-modal dd {
  margin-left: 60px;
}
dt {
  margin-top: 10px;
}
dd.no-data {
  color: #a6a6a6;
}
.bubble {
  position: absolute;
  top: -42px;
  right: -60px;
  min-width: 140px;
  background: #000;
  border-radius: 8px;
  color: #fff;
  padding: 5px;
  text-align: center;
}
.bubble:before {
  border-width: 5px 10px 0 10px;
  top: 30px;
  left: 40%;
}
.bubble:after {
  border-width: 5px 10px 0 10px;
  top: 30px;
  left: 40%;
}
.product-bubble::before, .product-bubble::after {
  border-color: #000 transparent;
}
</style>



// WEBPACK FOOTER //
// src/view/warehouseSc/components/ShippingInfoModal.vue